import {Component, EventEmitter, Output, Input} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {ButtonDirective} from 'primeng/button';

@Component({
  selector: 'app-export-button',
  standalone: true,
  templateUrl: './export-button.html',
  imports: [
    TranslatePipe,
    ButtonDirective
  ],
  styleUrl: './export-button.scss'
})
export class ExportButton {
  @Input() loading: boolean = false;
  @Input() disabled: boolean = false;
  @Output() export = new EventEmitter<void>();
}
